import React, { useEffect, useState } from 'react'
import { Card, Table, Form, Modal, InputGroup } from 'react-bootstrap';
import { cargos } from '../../config/arreglos';
import { toast } from 'react-toastify';
import { deleteBd, insertTableBd, updateTableBd } from '../../config/functions'

export const CardCuadrilla = ({
    cuadrilla,
    horas,
    empleados,
    idrde,
    getDetalleEmpleados,
    cargosRig,
    descanso,
    empleadosAyer,
    verificado,
    obreros,
    mobile,
    setEmpleadosDisponiblesBack,
    maxHoras = 8
}) => {

    const [empleadosDisponibles, setEmpleadosDisponibles] = useState([])

    const [cargosEmpl, setCargosEmpl] = useState(cargos)
    const user = JSON.parse(localStorage.getItem("token")).userName;

    const [empleado, setEmpleado] = useState('')
    const [empleadoCargo, setEmpleadoCargo] = useState((horas === '00:00-00:00' && !descanso) ? 'OBRERO DE PATIO' : '')
    const [empleadoHoras, setEmpleadoHoras] = useState(0)
    const [jornada, setJornada] = useState('') // Estado para jornada (D/N/null)

    const [empleadoSeleccionado, setEmpleadoSeleccionado] = useState({})
    const [empleadoEditar, setEmpleadoEditar] = useState('')
    const [cargoEditar, setCargoEditar] = useState('')
    const [horasEditar, setHorasEditar] = useState(0)
    const [jornadaEditar, setJornadaEditar] = useState('') // Estado para editar jornada
    const [idEditar, setIdEditar] = useState(0)

    const [nuevoEmpleado, setNuevoEmpleado] = useState(false)
    const [nuevoCargo, setNuevoCargo] = useState(false)

    const [visible, setVisible] = useState(true)
    const toggleVisibility = () => { setVisible(!visible) }

    const [showModal, setShowModal] = useState(false)
    const [refresh, setRefresh] = useState(false);

    const [empF, setEmpF] = useState([])

    useEffect(() => {
        const empFTemp = empleadosAyer.filter(op =>
            op.cargo !== 'SUPERVISOR' &&
            op.cargo !== 'ELECTRICISTA' &&
            op.cargo !== 'MECANICO' &&
            op.cargo !== 'OBRERO DE PATIO' &&
            op.cargo !== 'HSE' &&
            op.cargo !== 'PUSHER' &&
            op.cargo !== 'COMPANYMAN'
        );
        setEmpF(empFTemp)
    }, [empleadosAyer])

    const guardarEmpleado = async () => {
        if (!empleado.trim()) {
            toast.warning('El nombre no puede estar vacío.');
            return;
        }
        // Validar duplicados
        if (cuadrilla.some(op => (op.empleado).toLocaleUpperCase() === empleado.toLocaleUpperCase())) {
            toast.warning('Este empleado ya está en la cuadrilla.');
            return;
        }
        if (!empleadoCargo.trim() && obreros === false) {
            toast.warning('El cargo no puede estar vacío.');
            return;
        }

        if (empleadoHoras === 0 && !descanso) {
            toast.warning('Las horas no pueden estar vacías.');
            return;
        }

        // Validar jornada para obreros de patio
        if (obreros && !jornada.trim()) {
            toast.warning('Debe seleccionar la jornada (DIA o NOCHE) para obreros de patio.');
            return;
        }

        const dataSend = {
            id_rde: parseInt(idrde),
            empleado: empleado.toLocaleUpperCase(),
            cargo: obreros ? 'OBRERO DE PATIO' : empleadoCargo.toLocaleUpperCase(),
            horas: descanso ? 0 : parseFloat(empleadoHoras),
            horario: descanso ? '00:00-00:00' : horas,
            jornada: obreros ? jornada : null, // Solo enviar jornada para obreros de patio
            usuario: user,
        }
        const response = await insertTableBd('createregistrediarioDE', dataSend)
        if (response) {
            setRefresh((prev) => !prev)
            setEmpleado('')
            setEmpleadoCargo('')
            setEmpleadoHoras(0)
            setJornada('') // Resetear jornada
            setNuevoCargo(false)
            setNuevoEmpleado(false)
            toast.success('Empleado guardado exitosamente')
            setEmpleadosDisponiblesBack((prev) => prev.filter(emp => emp.name !== empleado.toLocaleUpperCase()))
        } else {
            toast.error('Error al guardar el supervisor')
        }
    }

    const guardarEmpleadosAyer = async () => {

        if (empF.length === 0) return;

        toast.info(
            <div>
                <p>¿Desea asignar los mismos empleados de ayer?</p>
                <table className='table table-sm table-striped' style={{ fontSize: '9px' }}>
                    <thead>
                        <tr>
                            <th>Nombre</th>
                            <th>Cargo</th>
                            <th>Horas</th>
                        </tr>
                    </thead>
                    <tbody>
                        {empF.map((empleado) => (
                            <tr key={empleado.id}>
                                <td>{empleado.empleado}</td>
                                <td>{empleado.cargo}</td>
                                <td>{empleado.horas}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <button
                        className="btn btn-sm btn-success"
                        onClick={async () => {
                            try {
                                const promises = empF.map((empleado) => {
                                    const dataSend = {
                                        id_rde: parseInt(idrde),
                                        empleado: empleado.empleado,
                                        cargo: empleado.cargo,
                                        horas: empleado.horas,
                                        horario: empleado.horario,
                                        usuario: user,
                                    };
                                    return insertTableBd('createregistrediarioDE', dataSend);
                                });

                                await Promise.all(promises);
                                setRefresh((prev) => !prev);
                                toast.success('Empleados de ayer guardados exitosamente en el día de hoy');
                            } catch (error) {
                                toast.error('Ocurrió un error al guardar algunos empleados, intente manualmente');
                            }
                        }}
                    >
                        Confirmar
                    </button>
                    <button
                        className="btn btn-sm btn-danger"
                        onClick={() => toast.dismiss()}
                    >
                        Cancelar
                    </button>
                </div>
            </div>,
            {
                autoClose: false,
                position: 'top-center',
            }
        );
    };

    const opciones = (op) => {
        setEmpleadoSeleccionado(op)
        setIdEditar(op.id)
        setEmpleadoEditar(op.empleado)
        setCargoEditar(op.cargo)
        setHorasEditar(op.horas)
        setJornadaEditar(op.jornada || '') // Cargar jornada existente
        setShowModal(true)
    }

    const guardarEditarEmpleado = async () => {
        if (!empleadoEditar.trim()) {
            toast.warning('El nombre no puede estar vacío.');
            return;
        }
        if (!cargoEditar.trim()) {
            toast.warning('El cargo no puede estar vacío.');
            return;
        }

        if ((!descanso && (horasEditar === 0 || horasEditar === '' || horasEditar === null))) {
            toast.warning('Las horas no pueden estar vacías.');
            return;
        }

        // Validar jornada para obreros de patio al editar
        if (cargoEditar === 'OBRERO DE PATIO' && !jornadaEditar.trim()) {
            toast.warning('Debe seleccionar la jornada (DIA o NOCHE) para obreros de patio.');
            return;
        }

        const dataSend = {
            id: idEditar,
            empleado: empleadoEditar.toLocaleUpperCase(),
            cargo: cargoEditar.toLocaleUpperCase(),
            horas: descanso ? 0 : parseFloat(horasEditar),
            horario: descanso ? '00:00-00:00' : horas,
            jornada: cargoEditar === 'OBRERO DE PATIO' ? jornadaEditar : null, // Solo enviar jornada para obreros de patio
            usuario: user,
        }
        const response = await updateTableBd('updateregistrediarioDE', dataSend)
        if (response) {
            setRefresh((prev) => !prev)
            setEmpleado('')
            setEmpleadoCargo('')
            setEmpleadoHoras(0)
            setJornada('') // Resetear jornada
            toast.success('editado exitosamente')
            setShowModal(false)
        } else {
            toast.error('Error al editar el empleado')
        }
    }

    const eliminarEmpleado = async () => {
        if (window.confirm('Esta seguro de continuar?')) {
            try {
                await deleteBd(idEditar, 'deleteregisterdiarioDE')
                toast.success('Se desasignó el empleado');
                setRefresh((prev) => !prev);
                setShowModal(false)
            } catch (error) {
                console.error(error);
            }
        }
    }

    //-------------------------------------------------------

    const organizarEmpleados = () => {
        const empleadosUnicos = empleados.filter(
            (emp, idx, self) =>
                idx === self.findIndex(e =>
                    e.name.trim().toLocaleUpperCase() === emp.name.trim().toLocaleUpperCase()
                )
        );
        const empleadosDisponibles = empleadosUnicos.filter(empleado => {
            return !cuadrilla.some(op =>
                op.empleado.trim().toLocaleUpperCase() === empleado.name.trim().toLocaleUpperCase()
            )
        });
        if (empleadosDisponibles.length === 0) setNuevoEmpleado(true)
        else setNuevoEmpleado(false)
        setEmpleadosDisponibles(empleadosDisponibles)
    }

    //------------------------------------------------------

    useEffect(() => { organizarEmpleados() }, [cuadrilla, empleados])
    useEffect(() => { getDetalleEmpleados() }, [refresh]);

    useEffect(() => {
        if (cargosRig && cargosRig.length > 0) {
            const cargosUnicos = [...new Set(cargosRig.map(c => c.name))]
            const cargosFiltrados = cargos.filter(c => !cargosUnicos.includes(c.name))
            const cargosUnificados = cargosRig.map(c => ({ id: c.id, name: c.name }))
            const cargosParaEmpleados = cargosUnificados.concat(cargosFiltrados)
                .filter(c =>
                    c.name !== 'SUPERVISOR' &&
                    c.name !== 'ELECTRICISTA' &&
                    c.name !== 'MECANICO' &&
                    c.name !== 'OBRERO DE PATIO' &&
                    c.name !== 'HSE' &&
                    c.name !== 'PUSHER' &&
                    c.name !== 'COMPANYMAN'
                )
            const cargosParaDescanso = cargosUnificados.concat(cargosFiltrados)
            setCargosEmpl(descanso ? cargosParaDescanso : cargosParaEmpleados)
        } else setCargosEmpl(cargos)
    }, [cargosRig])


    //------------------------------------------------------

    return (
        <>
            <Card className={`border-${cuadrilla.length === 0 ? 'warning' : 'success'}`} >
                <Card.Body className={`${mobile ? 'p-0' : ''}`}>
                    <Card.Title
                        className={`d-flex justify-content-between align-items-center ${mobile && 'mb-0'}`}
                        style={{ fontSize: mobile && '14px' }}>

                        {descanso
                            ? 'Cuadrilla en descanso'
                            : horas === '00:00-00:00'
                                ? 'Obreros de Patio'
                                : 'Cuadrilla ' + horas}

                        {cuadrilla.length > 0 && (
                            <Card.Subtitle className="text-muted" style={{ fontSize: mobile && '12px' }}>
                                (Empleados: {cuadrilla.length})
                            </Card.Subtitle>
                        )}

                        <div className="btn-group">
                            {!verificado && cuadrilla.length === 0 && (
                                <button
                                    className={`btn btn-sm btn-warning fa-solid fa-list-check`}
                                    disabled={empF.length === 0}
                                    onClick={() => guardarEmpleadosAyer()}
                                    title={`${empleadosAyer.length === 0 ? 'No hay empleados de Ayer' : 'Asignar empleados de Ayer'}`}
                                />
                            )}
                            <button
                                className={`btn btn-sm btn-secondary fa-solid fa-angle-${visible ? 'up' : 'down'}`}
                                onClick={toggleVisibility}
                            />
                        </div>

                    </Card.Title>
                    {visible && (
                        <Table
                            striped bordered hover
                            size="sm"
                            className={
                                `align-middle table-sm 
                                ${mobile ? 'mb-0 ' : ' '}
                                ${descanso
                                    ? 'table-info'
                                    : horas === '00:00-00:00'
                                        ? 'table-success'
                                        : 'table-secondary'} `
                            }
                            style={{ fontSize: '10px' }}
                            responsive>
                            <thead>
                                <tr>
                                    <th></th>
                                    <th>Nombre</th>
                                    <th>Cargo</th>
                                    {obreros && <th>Jornada</th>}
                                    <th colSpan={2}>Horas</th>
                                </tr>
                            </thead>
                            <tbody>

                                {cuadrilla.map((op, index) => (
                                    <tr key={index}
                                        title={!verificado ? 'doble click para editar' : null}
                                        onDoubleClick={() => {
                                            if (verificado) return
                                            opciones(op)
                                        }} >
                                        <td>{index + 1}</td>
                                        <td>{op.empleado}</td>
                                        <td>{op.cargo}</td>
                                        {obreros && (
                                            <td>
                                                {op.jornada === 'D' ? 'DIA' : op.jornada === 'N' ? 'NOCHE' : 'N/A'}
                                            </td>
                                        )}
                                        <td colSpan={2}>{op.horas}</td>
                                    </tr>
                                ))}
                                {!verificado && (
                                    <tr>
                                        <td colSpan={2} className={`${mobile && 'p-0'}`}>
                                            {!nuevoEmpleado
                                                ? (
                                                    <Form.Select
                                                        aria-label={'empleado'}
                                                        id={`empleado-${horas}`}
                                                        size="sm"
                                                        style={{ fontSize: mobile && '11px' }}
                                                        onChange={(e) => {
                                                            if (e.target.value === 'Nuevo Empleado') {
                                                                setNuevoEmpleado(true)
                                                                setEmpleado('')
                                                            } else setEmpleado(e.target.value)
                                                        }}
                                                        value={empleado}>
                                                        <option value=''>Seleccione Empleado</option>
                                                        {empleadosDisponibles.map(op => (
                                                            <option key={op.name} value={op.name}>{op.name}</option>
                                                        ))}
                                                        <option value={'Nuevo Empleado'}>Nuevo Empleado</option>
                                                    </Form.Select>
                                                )
                                                : (
                                                    <Form.Control
                                                        type="text"
                                                        placeholder='Nuevo Empleado'
                                                        style={{ fontSize: mobile && '11px' }}
                                                        title='esc to cancel'
                                                        id={`empleadoNuevo-${horas}`}
                                                        aria-label={'empleadoNuevo'}
                                                        size="sm"
                                                        onKeyDown={(e) => {
                                                            if (e.key === 'Escape') {
                                                                setNuevoEmpleado(false)
                                                                setEmpleado('')
                                                            }
                                                        }}
                                                        onChange={(e) => setEmpleado(e.target.value)}
                                                        value={empleado} />
                                                )
                                            }

                                        </td>
                                        <td className={`${mobile && 'p-0'}`}>
                                            {!nuevoCargo
                                                ? (
                                                    <Form.Select
                                                        aria-label={'cargoNuevo'}
                                                        size="sm"
                                                        id={`empleadoCargo-${horas}`}
                                                        style={{ fontSize: mobile && '11px' }}
                                                        disabled={horas === '00:00-00:00' && !descanso}
                                                        onChange={(e) => {
                                                            if (e.target.value === 'Nuevo Cargo') {
                                                                setNuevoCargo(true)
                                                                setEmpleadoCargo('')
                                                            } else setEmpleadoCargo(e.target.value)
                                                        }}
                                                        value={empleadoCargo}>
                                                        {horas === '00:00-00:00' && !descanso
                                                            ? <option value={'OBRERO DE PATIO'}>OBRERO DE PATIO</option>
                                                            : <>
                                                                <option value={''}>Seleccione Cargo</option>
                                                                {cargosEmpl.map(op => (
                                                                    <option key={op.name} value={op.name}>{op.name}</option>
                                                                ))}
                                                                < option value={'Nuevo Cargo'}>Nuevo Cargo</option>
                                                            </>
                                                        }
                                                    </Form.Select>
                                                )
                                                : (
                                                    <Form.Control
                                                        type="text"
                                                        placeholder='Nuevo Cargo'
                                                        style={{ fontSize: mobile && '11px' }}
                                                        title='esc to cancel'
                                                        id={`empleadoCargoNuevo-${horas}`}
                                                        aria-label={'cargoNuevo'}
                                                        size="sm"
                                                        onKeyDown={(e) => {
                                                            if (e.key === 'Escape') {
                                                                setNuevoCargo(false)
                                                                setEmpleadoCargo('')
                                                            }
                                                        }}
                                                        onChange={(e) => setEmpleadoCargo(e.target.value)}
                                                        value={empleadoCargo} />
                                                )
                                            }

                                        </td>
                                        {obreros && (
                                            <td className={`${mobile && 'p-0'}`}>
                                                <Form.Select
                                                    aria-label={'jornada'}
                                                    size="sm"
                                                    id={`jornada-${horas}`}
                                                    style={{ fontSize: mobile && '11px' }}
                                                    onChange={(e) => setJornada(e.target.value)}
                                                    value={jornada}>
                                                    <option value=''>Seleccione Jornada</option>
                                                    <option value='D'>DIA</option>
                                                    <option value='N'>NOCHE</option>
                                                </Form.Select>
                                            </td>
                                        )}
                                        <td className={`${mobile && 'p-0'}`}>
                                            <Form.Control
                                                type="number"
                                                id={`empleadoHoras-${horas}`}
                                                disabled={descanso}
                                                aria-label={'horasNuevo'}
                                                style={{ fontSize: mobile && '11px' }}
                                                min={0}
                                                max={maxHoras}
                                                size="sm"
                                                onChange={(e) => {
                                                    if (e.target.value < 0 || e.target.value > maxHoras || e.target.value === '') {
                                                        toast.warning(`Las horas deben estar entre 0 y ${maxHoras}`)
                                                        e.target.value = 0
                                                    }
                                                    setEmpleadoHoras(e.target.value)
                                                }}
                                                value={empleadoHoras}
                                            />
                                        </td>
                                        <td className={`${mobile && 'p-0'}`}>
                                            <button
                                                className='btn btn-sm btn-primary fa-solid fa-floppy-disk'
                                                onClick={() => guardarEmpleado()}
                                            />
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </Table>
                    )}
                </Card.Body>
            </Card >

            {showModal && (
                <Modal show={showModal} onHide={() => setShowModal(false)} size="sm" centered>
                    <Modal.Header closeButton>
                        <Modal.Title style={{ fontSize: '18px' }}> Opciones de Edición </Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <InputGroup className="mb-2" size="sm">
                            <InputGroup.Text id={'empleadoEditar'}>Empleado</InputGroup.Text>
                            <Form.Select
                                aria-label={'empleadoEditar'}
                                id={`empleadoNombre`}
                                size="sm"
                                onChange={(e) => setEmpleadoEditar(e.target.value)}
                                value={empleadoEditar}>
                                <option value={empleadoSeleccionado.empleado}>{empleadoSeleccionado.empleado}</option>
                                {empleadosDisponibles.map(op => (
                                    <option key={op.name} value={op.name}>{op.name}</option>
                                ))}
                            </Form.Select>
                        </InputGroup>
                        <InputGroup className="mb-2" size="sm">
                            <InputGroup.Text id={'cargoEditar'}>Cargo</InputGroup.Text>
                            <Form.Select
                                aria-label={'cargoEditar'}
                                id={`empleadoCargo`}
                                size="sm"
                                onChange={(e) => setCargoEditar(e.target.value)}
                                disabled={cargoEditar === 'OBRERO DE PATIO'}
                                value={cargoEditar}>
                                {cargoEditar === 'OBRERO DE PATIO'
                                    ? <option value={cargoEditar}>{cargoEditar}</option>
                                    : cargosEmpl.map(op => (
                                        <option key={op.name} value={op.name}>{op.name}</option>
                                    ))
                                }
                            </Form.Select>
                        </InputGroup>
                        {cargoEditar === 'OBRERO DE PATIO' && (
                            <InputGroup className="mb-2" size="sm">
                                <InputGroup.Text id={'jornadaEditar'}>Jornada</InputGroup.Text>
                                <Form.Select
                                    aria-label={'jornadaEditar'}
                                    id={`jornadaSelect`}
                                    size="sm"
                                    onChange={(e) => setJornadaEditar(e.target.value)}
                                    value={jornadaEditar}>
                                    <option value=''>Seleccione Jornada</option>
                                    <option value='D'>DIA</option>
                                    <option value='N'>NOCHE</option>
                                </Form.Select>
                            </InputGroup>
                        )}
                        <InputGroup className="mb-2" size="sm">
                            <InputGroup.Text id={'horasEditar'}>Horas</InputGroup.Text>
                            <Form.Control
                                type="number"
                                id={`empleadoHoras`}
                                aria-label={'horasEditar'}
                                disabled={descanso}
                                min={0}
                                max={maxHoras}
                                size="sm"
                                onChange={(e) => {
                                    if (e.target.value < 0 || e.target.value > maxHoras || e.target.value === '') {
                                        toast.warning(`Las horas deben estar entre 0 y ${maxHoras}`)
                                        e.target.value = 0
                                    }
                                    setHorasEditar(e.target.value)
                                }}
                                value={horasEditar} />
                        </InputGroup>
                    </Modal.Body>

                    <Modal.Footer>
                        <button
                            className='btn btn-sm btn-secondary'
                            onClick={() => setShowModal(false)}>
                            Cerrar
                        </button>
                        <button
                            className='btn btn-primary fa-solid fa-floppy-disk'
                            title='Guardar Cambios'
                            onClick={() => guardarEditarEmpleado()} />
                        <button
                            className='btn btn-danger fa-solid fa-trash-can'
                            title='Eliminar Empleado'
                            onClick={() => eliminarEmpleado()} />
                    </Modal.Footer>
                </Modal>
            )}
        </>
    );
}
